import { Link } from "react-router-dom";
import AnimatedSection from "../../../components/base/AnimatedSection";

export default function HeroSection() {
  const handleContactClick = () => {
    const el = document.getElementById("contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="min-h-screen flex items-center bg-white pt-16">
      <div className="max-w-7xl mx-auto px-6 w-full py-20">
        <div className="flex items-stretch gap-0">
          {/* Red vertical line */}
          <div className="w-1 min-h-full" style={{ backgroundColor: "#E8150C" }}></div>

          {/* Content */}
          <div className="pl-10 flex-1">
            <AnimatedSection delay={0}>
              <span className="inline-block text-brand-red font-body text-sm font-medium tracking-widest uppercase mb-6">
                Partner Externo Profesional
              </span>
            </AnimatedSection>

            <AnimatedSection delay={100}>
              <h1 className="font-heading font-black text-brand-black leading-none tracking-tight mb-8"
                style={{ fontSize: "clamp(2.8rem, 6vw, 5rem)" }}>
                GESTIÓN<br />
                PROFESIONAL<br />
                <span style={{ color: "#E8150C" }}>PARA COMPETICIONES</span><br />
                AMATEURS
              </h1>
            </AnimatedSection>

            <AnimatedSection delay={200}>
              <p className="font-body text-brand-anthracite text-lg leading-relaxed max-w-xl mb-10">
                Fair Play Global se encarga de toda la estructura administrativa, fiscal y organizativa de tu liga para que tú solo te preocupes del deporte.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={300}>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/servicios"
                  className="bg-brand-red hover:bg-brand-red-hover text-white font-body font-medium px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  Conoce nuestros servicios
                </Link>
                <button
                  onClick={handleContactClick}
                  className="border-2 border-brand-red text-brand-red hover:bg-brand-red hover:text-white font-body font-medium px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
                >
                  Contactar ahora
                </button>
              </div>
            </AnimatedSection>

            {/* Stats row */}
            <AnimatedSection delay={400}>
              <div className="flex flex-wrap gap-10 mt-16 pt-10 border-t border-brand-pearl">
                <div>
                  <p className="font-heading font-black text-brand-red text-4xl leading-none">100%</p>
                  <p className="font-body text-brand-gray-mid text-sm mt-1">Cumplimiento legal</p>
                </div>
                <div>
                  <p className="font-heading font-black text-brand-red text-4xl leading-none">0€</p>
                  <p className="font-body text-brand-gray-mid text-sm mt-1">Riesgo fiscal para el organizador</p>
                </div>
                <div>
                  <p className="font-heading font-black text-brand-red text-4xl leading-none">24/7</p>
                  <p className="font-body text-brand-gray-mid text-sm mt-1">Soporte durante la temporada</p>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Right image */}
          <div className="hidden lg:block flex-shrink-0 w-80 xl:w-96">
            <AnimatedSection delay={150}>
              <div className="w-full h-96 overflow-hidden rounded-lg">
                <img
                  src="https://static.readdy.ai/image/b4936df4b10639d97e7d05f0664429e8/271a596f71cb96c0ee6edd987535f294.png"
                  alt="Gestión profesional de ligas amateurs"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </section>
  );
}